import { Install, InstallCommission } from "../../utils/types";

export interface ContactInstallCommission {
  install: Install;
  commission: InstallCommission;
}

export const getContactInstallCommissions = (
  contactUuid: string,
  installs: Install[]
) => {
  const items: ContactInstallCommission[] = [];

  installs.forEach((install) => {
    install.commissions.forEach((commission) => {
      if (commission.contact_uuid === contactUuid) {
        items.push({ install, commission });
      }
    });
  });

  return items;
};
